import {defaultCountry, defaultPhoneCode, defaultCurrency} from './default';
export class BankDetails {
    constructor(bank_detail) {
        this.bank_name = '';
        this.copy_debit = '0';
        this.city = '';
        this.bank_account_country_code = defaultCountry;
        this.bank_account_currency = defaultCurrency;
        this.bank_country_code = defaultCountry;
        // this.country_code = defaultCountry; //i think this field is coming from back end.
        this.bank_account_number = '';
        this.bank_sort_code = '';
        this.locality = '';
        this.iban = '';
        this.swift = '';
        this.is_valid = '';
        this.account_holder_name = '';
        this.street_line_1 = '';
        this.account_type = '';
        this.bank_account_type = '';
        this.house_number = '';
        this.house_name = '';
        this.zip_code = '';
        this.county_code = '';
        this.funding_currency = '';
        this.convenience_fee_funding = '';
        this.deposit_account = '';
        this.chargeback_account = '';
        this.fee_account = '';
        this.dda_number = '';
        this.routing_number = '';
        this.copy_other_account = '';
        this.settlement_method = '';
        this.faster_payments = '';
        this.disabled_faster_payments = '';
        this.bank_creditor_id = '';
        if (!!bank_detail) {
            this.setData(bank_detail);
        }
    }

    setData(data) {
        let data_keys = Object.keys(data);
        data_keys.map(f => {
            //these are set to match the alliance else it may break on submission
            if (f === 'bank_account_country_code' || f === 'bank_country_code') {
                this[f] = data[f] === defaultCountry ? data[f] : defaultCountry;
            } else if (f === 'bank_account_currency') { //if
                this[f] = data[f] === defaultCurrency ? data[f] : defaultCurrency;
            } else {
                this[f] = data[f]
            }
        });
    }

    get isGBPBank() {
        let gbp_required = true;
        this.bank_account_currency === '' || (this.bank_account_currency === 'GBP' && this.bank_account_country_code === '826') ? gbp_required = true: gbp_required = false;
        return gbp_required;
    }

    get isNORBank() {
        let nor_required = true;
        this.bank_account_country_code === '578' ? nor_required = true: nor_required = false;
        return nor_required;
    }

    get isGERBank() {
        return this.bank_account_country_code === '276';
    }

    get isPOLBank() {
        return this.bank_account_country_code === '616';
    }

    get isIRLBank() {
        return this.bank_account_country_code === '372';
    }
}

export class Bank {
    constructor(bank) {
        this.debit = new BankDetails();
        this.credit = new BankDetails();
        this.equipment = new BankDetails();

        if (!!bank) {
            this.setData(bank);
        }
    }

    setData(data) {
        let data_keys = Object.keys(data);
        data_keys.map(f => {
            this[f.toLowerCase()] = new BankDetails(data[f]);
        });
    }
}

export class PostingAccount extends BankDetails {
    constructor(postingAccount) {
        super(postingAccount);
        this.account_type_id = '';
        this.account_type_setup_id = '';
        this.currency_code = '';
        this.days_credit = '';

        if (!!postingAccount) {
            this.setData(postingAccount);
        }
    }

    setData(data) {
        let data_keys = Object.keys(data);
        data_keys.map(f => {
            this[f] = data[f]
        });
    }
}

export class CurrencyAccounts {
    constructor(currencyAccount) {
        this.currency = '';
        this.accounts = [new PostingAccount()];

        if (!!currencyAccount) {
            this.setData(currencyAccount);
        }
    }

    setData(data) {
        let data_keys = Object.keys(data);
        data_keys.map(f => {
            if(f === 'accounts') {
                this[f] = data[f].map(obj => new PostingAccount(obj));
            } else {
                this[f] = data[f]
            }
        });
    }
}
